import { UseMutationOptions } from 'react-query'
import { HTTPError } from '../../../api/fetch/decorate-fetch'
import {
  DeleteVulnerabilitieswithFiltersArgs,
  deleteVulnerabilitiesWithFilters
} from '../../../api/mutations/delete-vulnerabilities/delete-vulnerabilities'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'

export interface DeleteResponse {
  jobStatus: {
    id: string
    total: number
    progress: number
  }
}

export function useDeleteVulnerabilitiesWithFilters(
  options?: UseMutationOptions<
    DeleteResponse,
    HTTPError,
    DeleteVulnerabilitieswithFiltersArgs
  >
) {
  return useContrastMutation<
    DeleteResponse,
    HTTPError,
    DeleteVulnerabilitieswithFiltersArgs
  >(deleteVulnerabilitiesWithFilters, options)
}
